import { useModel } from '@rhino-project/core/hooks';
import { networkApiCall } from '@rhino-project/core/lib';
import { useMutation } from '@tanstack/react-query';

// Mints a short-lived preview session for a team season's portal and opens
// it in a new tab. Server-side authorization is the team season :show? check.
export function usePreviewPortal(teamSeasonId: string | number | undefined) {
  const teamSeasonModel = useModel('team_season');

  const { mutate: previewPortal, isPending } = useMutation({
    mutationFn: (id: number | string) =>
      networkApiCall(`${teamSeasonModel.path}/${id}/preview_portal_session`, {
        method: 'post'
      })
  });

  const openPreview = () => {
    if (!teamSeasonId) return;
    previewPortal(teamSeasonId, {
      onSuccess: (response) => {
        const previewUrl = (response as { data?: { preview_url?: string } })
          ?.data?.preview_url;
        if (previewUrl)
          window.open(previewUrl, '_blank', 'noopener,noreferrer');
      }
    });
  };

  return { openPreview, isPending };
}
